import { NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { HttpModule } from '@angular/http';
import { FormsModule } from "@angular/forms";
import { CabeceraModule } from "../../../components/common/cabecera/cabecera.module";
import { DataTableModule } from "angular2-datatable";
import { Ng2Bs3ModalModule } from "ng2-bs3-modal/ng2-bs3-modal";
import { Ng2Webstorage } from "ngx-webstorage/dist/app";
import { siniestros } from "./siniestros.component";
import { siniestralidadService } from "./siniestralidad.service";
import { AplicacionesTransporteModule } from "../aplicacionesTransporte/aplicaciones-transporte.module";
import { SolicitudVehiculosModule } from "../solicitudes/solicitud-vehiculos.module";
import { SolicitudEquiposModule } from "../solicitudes/solicitud-equipo.module";
import { SolicitudOtrosModule } from "../solicitudes/solicitud-otros.module";
import { PolizasVencidasNoLiberadasService } from "../fianzas/polizasVencidasNoLiberadas/polizas-vencidasnoLiberadas.service";
import { RedesEmpresaModule } from "../vamEmpresa/redes/redesEmpresa.module";
import { CondicionesVamModule } from "../vamEmpresa/condiciones/condiciones.module";
import { MovimientosVamModule } from "../vamEmpresa/movimientos/movimientosVam.module";
import { ListadosModule } from "../vamEmpresa/listados/listados.module";
import { SolicitudMovimientosModule } from "../vamEmpresa/solicitudes/solicitudes-movimientos.module";
import { CalendarModule } from 'primeng/primeng';
//import {ResumenGrComponent} from './resumengr.component';
import { ChartsModule } from 'ng2-charts'
import { RankingTitularesGrComponent } from "./rankingTitularesgr.component";
import {DetalleDiagnosticoComponentGr} from './detalle-diagnosticogr.componet';
import {ProveedoresComponentGr} from './proveedoresgr.component';
import {MaternidadComponentGr} from './maternidadgr.component';
import { Ng2CompleterModule } from "ng2-completer";


@NgModule({
    declarations: [siniestros],
    imports: [
        BrowserModule,
        HttpModule,
        FormsModule,
        CabeceraModule,
        DataTableModule,
        Ng2Bs3ModalModule,
        Ng2Webstorage,
        AplicacionesTransporteModule,
        SolicitudVehiculosModule,
        SolicitudEquiposModule,
        SolicitudOtrosModule,
        RedesEmpresaModule,
        CondicionesVamModule,
        ListadosModule,
        MovimientosVamModule,
        Ng2CompleterModule,
        CalendarModule,ChartsModule,
        SolicitudMovimientosModule],
        exports: [siniestros],
    providers: [siniestralidadService,PolizasVencidasNoLiberadasService]
})

export class siniestrosModule { }


// WEBPACK FOOTER //
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/src/app/views/empresas/polizasContratadas/siniestros.module.ts